module.exports = __webpack_public_path__ + "static/media/U1-T2-2-1.411607b8.vtt";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/U1-T2-2-1.vtt
// module id = 537
// module chunks = 0